import styled from "styled-components"

export const Wrapper = styled.article`
  max-width: var(--maxWidthPrimary);
  margin: 0 auto;
`

export const Überschrift = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: var(--gapS);
  padding: 0 15px;

  h1,
  h2 {
    text-align: center;
    white-space: pre-line;
  }

  .img__container {
    display: none;
    visibility: hidden;
    width: 100%;
    max-width: 100px;
    min-width: 100px;
    height: 100vh;
    max-height: 135px;
    min-height: 135px;
    margin-right: var(--gapS);
  }

  @media (max-width: 992px) {
    .img__container {
      display: block;
      visibility: visible;
    }

    h1,
    h2 {
      font-size: var(--fontSize-1);
      text-align: left;
    }
  }

  @media (max-width: 375px) {
  }
`

export const Jobs = styled.section`
  position: relative;
  display: inline-block;
  padding: var(--gapM) var(--gapL);
  color: var(--clr-purple);
  width: 100%;

  h2 {
    margin-bottom: var(--gapXS);
  }

  li {
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    display: inline-block;
    padding: 10px 15px;
    margin-top: var(--gapS);
    background: var(--clr-purple);
    -webkit-border-radius: var(--border-radius);
    -moz-border-radius: var(--border-radius);
    border-radius: var(--border-radius);
    color: white;
    -webkit-box-shadow: var(--box-shadow);
    -moz-box-shadow: var(--box-shadow);
    box-shadow: var(--box-shadow);
    white-space: nowrap;
    min-width: 200px;
    text-align: center;

    &:hover {
      background: var(--clr-dark-purple);
    }
  }

  @media (max-width: 768px) {
    padding: 0;
    width: 100%;

    li {
      margin-bottom: 15px;
    }
  }
`

export const Content = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  position: relative;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -moz-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -moz-box-align: center;
  align-items: center;
  margin-top: var(--gapS);
  padding-left: 100px;
  background: white;
  -moz-box-shadow: var(--box-shadow-secondary);
  -webkit-box-shadow: var(--box-shadow-secondary);
  box-shadow: var(--box-shadow-secondary);
  border-radius: var(--border-radius-secondary);
  -moz-border-radius: var(--border-radius-secondary);
  -webkit-border-radius: var(--border-radius-secondary);

  .img__container {
    width: 100vw;
    max-width: 250px;
    height: 100vh;
    max-height: 350px;
    margin-right: var(--gapL);
  }

  a {
    &:last-child {
      margin-top: var(--gapXS);
      -webkit-align-self: flex-end;
      align-self: flex-end;
      justify-self: flex-end;
    }
  }

  @media (max-width: 992px) {
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    padding-left: 0;
    padding: 30px;
    .img__container {
      display: none;
      visibility: hidden;
    }
  }
`
